<template>
    <div class="tab-content">
        <!--{{selectedRow}}-->
        <el-tabs  v-model="activeTab" @tab-click="handleClick">
            <!-- purchase -->
            <el-tab-pane :disabled="!projectPermission.createTaskSCMPurchasingPurchaseRequest" :label="$t('project_tab_scm_purchasing_purchaseRequest')" name="purchaseRequest">
              <el-card>
                <el-table
                        :data="purchaseList"
                        style="width: 100%"
                        :cell-class-name="cellClassName"
                        :row-class-name="tableRowClassName"
                        :header-cell-class-name="headerCellClassName"
                        @cell-click="cellClick">
                    <el-table-column
                            type="index"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            label="No."
                            prop="purchaseRequest.code"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            label="Order Date"
                            width="110">
                        <template slot-scope="scope">
                            <div v-if="scope.row.purchaseRequest.orderDate">
                                {{moment(scope.row.purchaseRequest.orderDate.toString(), 'X').format('D MMM YY')}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="purchaseRequest.vendor.name"
                            label="Vendor"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="status"
                            label="Status"
                            width="100">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.purchaseRequest.status === 2"
                                        size="mini"
                                        type="primary"
                                        plain>
                                Submitted
                            </el-button>
                            <el-button v-if="scope.row.purchaseRequest.status === 3"
                                        size="mini"
                                        type="success"
                                        plain>
                                Approved
                            </el-button>
                            <el-button v-if="scope.row.purchaseRequest.status === 4"
                                        size="mini"
                                        type="danger"
                                        plain>
                                Rejected
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="purchaseRequest.subTotal"
                            label="Subtotal"
                            width="70">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.purchaseRequest.subTotal)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="purchaseRequest.totalAmount"
                            label="Total Amount"
                            width="100">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.purchaseRequest.totalAmount)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="purchaseRequest.paymentToVendor"
                            label="Payment to Vendor"
                            width="140">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.purchaseRequest.paymentToVendor)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Operations">
                        <template slot-scope="scope">
                            <div v-if="scope.row.purchaseRequest.status === 4">
                                <el-button
                                        size="mini"
                                        type="primary"
                                        plain
                                        icon="el-icon-edit"
                                        @click="handleEdit(scope.$index, scope.row)"></el-button>
                                <el-button
                                        size="mini"
                                        type="danger"
                                        plain
                                        icon="el-icon-delete"
                                        @click="handleDelete(scope.$index, scope.row)"></el-button>
                            </div>
                            <div v-if="scope.row.purchaseRequest.status === 3">
                                <el-button
                                        size="mini"
                                        type="primary"
                                        plain
                                        @click="handleOrder(scope.$index, scope.row)">Order</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
              </el-card>
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskSCMPurchasingRequestQuotation" :label="$t('project_tab_scm_purchasing_requestQuotation')" name="requestQuotation">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskSCMPurchasingPurchaseOrder" :label="$t('project_tab_scm_purchasing_purchaseOrder')" name="purchaseOrder">
              <el-card>
                <el-table
                        :data="purchaseOrderList"
                        style="width: 100%"
                        :cell-class-name="cellClassName"
                        :row-class-name="tableRowClassName"
                        :header-cell-class-name="headerCellClassName"
                        @cell-click="cellClickOrder">
                    <el-table-column
                            type="index"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            label="No."
                            prop="purchaseOrder.code"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            label="Order Date"
                            width="110">
                        <template slot-scope="scope">
                            <div v-if="scope.row.purchaseOrder.orderDate">
                                {{moment(scope.row.purchaseOrder.orderDate.toString(), 'X').format('D MMM YY')}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="purchaseOrder.vendor.name"
                            label="Vendor"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            label="Status"
                            width="100">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.purchaseOrder.status === 2"
                                        size="mini"
                                        type="primary"
                                        plain>
                                Submitted
                            </el-button>
                            <el-button v-if="scope.row.purchaseOrder.status === 3"
                                        size="mini"
                                        type="success"
                                        plain>
                                Approved
                            </el-button>
                            <el-button v-if="scope.row.purchaseOrder.status === 4"
                                        size="mini"
                                        type="danger"
                                        plain>
                                Rejected
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="purchaseOrder.subTotal"
                            label="Subtotal"
                            width="70">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.purchaseOrder.subTotal)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="purchaseOrder.totalAmount"
                            label="Total Amount"
                            width="100">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.purchaseOrder.totalAmount)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="purchaseOrder.paymentToVendor"
                            label="Payment to Vendor"
                            width="140">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.purchaseOrder.paymentToVendor)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Operations">
                        <template slot-scope="scope">
                            <div>
                                <el-button
                                        :disabled="!isInventoryManager"
                                        size="mini"
                                        type="primary"
                                        plain
                                        @click="handleUpdateOrder(scope.$index, scope.row)">Update</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
              </el-card>
            </el-tab-pane>

            <!-- <el-tab-pane label="Request Quotation (RQ)" name="requestQuotation">
              Current Service Under Development
            </el-tab-pane> -->

            <el-tab-pane :disabled="!projectPermission.createTaskSCMPurchasingPurchasePosting" :label="$t('project_tab_scm_purchasing_purchasePosting')" name="purchasePostingInvoice">
              Current Service Under Development
            </el-tab-pane>

        </el-tabs>

        <!--EDIT MODAL PURCHASES-->
        <PurchaseRequest  ref="purchaseRequest" @refreshPurchase="refreshPurchaseAfetrEdit"/>
        <!--EDIT MODAL PURCHASES-->

        <!--PURCHASE REQUEST INFO MODAL-->
        <purchaseRequestInfoModal ref="purchaseRequestInfoModal"/>
        <!--PURCHASE REQUEST INFO MODAL-->

        <!--PURCHASE REQUEST INFO MODAL-->
        <purchaseOrderInfoModal ref="purchaseOrderInfoModal"/>
        <!--PURCHASE REQUEST INFO MODAL-->

        <!--PURCHASE ORDER UPDATE MODAL-->
        <purchaseOrderUpdateModal ref="purchaseOrderUpdateModal"/>
        <!--PURCHASE ORDER UPDATE MODAL-->

    </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import PurchaseRequest from '@/components/purchases/purchaseRequestModal.vue'
  import purchaseRequestInfoModal from '@/components/purchases/purchaseRequestInfoModal.vue'
  import purchaseOrderInfoModal from '@/components/purchases/purchaseOrderInfoModal.vue'
  import purchaseOrderUpdateModal from '@/components/purchases/purchaseOrderUpdateModal.vue'


  export default {
    components: {
      PurchaseRequest,
      purchaseRequestInfoModal,
      purchaseOrderUpdateModal,
      purchaseOrderInfoModal
    },
    props: [
      'selectedRow',
      'projectPermission'
    ],
    computed: {
      isInventoryManager(){
        return this.$store.state.isInventoryManager
      },
      purchaseOrderList(){
        return this.$store.state.purchaseOrderList
      },
      purchaseList(){
        return this.$store.state.purchaseList
      }
    },
    data() {
      return {
        moment:moment,
        activeTab: 'purchaseRequest',
        editedTaskId: null
      }
    },
    methods: {
      handleClick(tab, event, projectTaskId){
        console.log('purchaseOrderList', this.purchaseOrderList)
        console.log('tab', tab)
        let loader = this.$loading.show();
        if(tab.name === 'purchaseOrder'){
          this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
        }else if (tab.name === 'purchaseRequest') {
          this.$store.dispatch('getPurchaseList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
        }
        loader.hide()
      },
      handleEdit(index, row){
        this.editedTaskId = row.projectTaskId
        console.log('index', index)
        console.log('row', row)
        this.$refs.purchaseRequest.openModalEdit(row.companyId, false, row.projectTaskId, row.purchaseRequestId, 'project', 'user');
      },
      refreshPurchaseAfetrEdit(){
        this.handleClick({name: 'purchaseRequest' }, 'click', this.editedTaskId)
        this.editedTaskId = null
      },
      handleDelete(index, row){
        console.log('index', index)
        console.log('row', row)

        this.$confirm('This will permanently delete the purchase. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/purchaseRequest/delete?id=${row.purchaseRequestId}`)
            .then(response => {
              this.handleClick({name: 'purchaseRequest'}, 'click', row.projectTaskId)
              this.$message({
                type: 'success',
                message: 'Delete completed'
              });
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });

      },
      handleOrder(index, row){
        console.log('index', index)
        console.log('row', row)
        this.$confirm('Create Purchase Order from Purchase Request. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/purchaseOrder/createFromRequest?type=projectTask&id=${row.purchaseRequestId}`)
            .then(response => {
              this.handleClick({name: 'purchaseRequest'})
              this.$message({
                type: 'success',
                message: 'Delete completed'
              });
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Canceled'
          });
        });
      },
      handleUpdateOrder(index, row){
        console.log('row', row)
        this.$refs.purchaseOrderUpdateModal.openModalUpdate(row.companyId, row.projectId, row.projectTaskId,  row.purchaseOrderId, 'projectTask', 'user');
      },
      cellClassName({row, column, rowIndex, columnIndex}){

      },
      tableRowClassName({row, rowIndex}) {
        return 'table-rows'
      },
      headerCellClassName({row, column, rowIndex, columnIndex}){

      },
      cellClick(row, column, event){
        console.log('row', row)
        if(column.label !== 'File' && column.label !== 'Operations'){
          this.$refs.purchaseRequestInfoModal.openModalInfo(row.companyId, row.projectId, row.projectTaskId,  row.purchaseRequestId, 'project', 'user');
        }
      },
      cellClickOrder(row, column, event){
        console.log('row', row)
        if(column.label !== 'File' && column.label !== 'Operations'){
          this.$refs.purchaseOrderInfoModal.openModalInfo(row.companyId, row.projectId, row.projectTaskId,  row.purchaseOrderId, 'projectTask', 'user');
        }
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
